module.exports = __webpack_public_path__ + "img/Profile-15.c348ce20.png";